import { ACTIONS, COLUMN_TYPE, TIPO_IMPOSTO_VALUES_DEFAULT } from "../../../../utils/financialHelper";
import FormTiposImposto from "./FormTiposImposto";
import useCrud from "../../../../hooks/useCrud";
import CrudTablePage from "../../../../components/Financial/CrudTablePage";

const TiposDeImposto = () => {
  const headCells = [
    { key: 'code', field: 'code', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Sigla' },
    { key: 'applicableTo', field: 'applicableTo', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Aplicável a' },
    { key: 'standardRate', field: 'standardRate', type: COLUMN_TYPE.PERCENTAGE, alignRight: false, label: 'Taxa Padrão' },
    { key: 'type', field: 'type', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Esfera' },
    { key: 'legislation', field: 'legislation', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Legislação' },
    { key: 'actions', field: 'actions', type: COLUMN_TYPE.BUTTONS, alignRight: true, label: 'Ações' },
  ];

  const funcionalidade = 'Tipo de Imposto'

  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    isLoadingSubmit,
    items: tiposImposto,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems: setImpostos,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
  } = useCrud('/tax-types', TIPO_IMPOSTO_VALUES_DEFAULT, funcionalidade);

  return (
    <CrudTablePage
      isLoading={isLoading}
      funcionalidade={funcionalidade}
      rows={tiposImposto}
      setRows={setImpostos}
      headCells={headCells}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
      dadoFoiModificado={dadoFoiModificado}
      setDadoFoiModificado={setDadoFoiModificado}
      open={open}
      title={title}
      buttonLabel={buttonLabel}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      action={action}
      handleOpen={handleOpen}
    >
      <FormTiposImposto
        values={values}
        setValues={setValues}
        isDelete={action === ACTIONS.DELETE}
        isLoadingSubmit={isLoadingSubmit}
      />
    </CrudTablePage>
  )
}

export default TiposDeImposto